import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import _ from 'lodash'

const FormInputContainer = ({

                                label,
                                children,
                                showError = false,
                                customClass = '',
                                labelStyle = {},
                                ...props,

                            }) => {

    const errorMessages = _.get(props, 'errorMessages', [])
    const errorCls = showError && errorMessages.length > 0 ? ' error ' : ' '

    return (
        <div className={customClass + errorCls + ' nrt-form-input-container'}>
            {
                label &&
                <label style={labelStyle}
                    //htmlFor={name}
                       onClick={this.onLabelClick}>
                    {label}
                </label>
            }


            {children}


            {
                !!errorMessages &&
                showError &&
                <div className={'error-msgs'}>
                    {
                        errorMessages.map((error, index) => (
                            <span key={`-error-${index}`} className={errorCls}>{error}</span>
                        ))
                    }
                </div>

            }
        </div>
    )
}


FormInputContainer.propTypes = {
    label: PropTypes.string.isRequired,
    errorMessages: PropTypes.array.isRequired,
    showError: PropTypes.bool,
    customClass: PropTypes.string,
    labelStyle: PropTypes.object,
}


export default FormInputContainer



// WEBPACK FOOTER //
// ./src/components/_common/FormInputContainer/index.js